import * as braze from '@braze/web-sdk'

export function initialize(apiKey, options) {
  if (typeof window !== 'undefined') {
    braze.initialize(apiKey, options)
  }
}

export function openSession() {
  if (typeof window !== 'undefined') {
    braze.openSession()
  }
}

export function automaticallyShowInAppMessages() {
  if (typeof window !== 'undefined') {
    braze.automaticallyShowInAppMessages()
  }
}

export function getUser() {
  if (typeof window !== 'undefined') {
    return braze.getUser()
  }
}

export function changeUser(externalId: string) {
  if (typeof window !== 'undefined') {
    return braze.changeUser(externalId)
  }
}

export function logCustomEvent(eventName: string, data: any) {
  if (typeof window !== 'undefined') {
    return braze.logCustomEvent(eventName, data)
  }
}

export function toggleLogging() {
  if (typeof window !== 'undefined') {
    return braze.toggleLogging()
  }
}
